import React, { ReactNode } from 'react';

interface IGrayBox {
    children: ReactNode,
    classes?: string,
}

const GrayBox = (props: IGrayBox) => {

    const { children, classes } = props;

    return (
        <div className={`bg-gray-100 border rounded text-gray-700 py-4 px-6 ${ classes ?? '' }`}>{ children }</div>
    )
};

export default GrayBox;